import { render } from "./EditReferatDetail.vue?vue&type=template&id=68dfb604&scoped=true&ts=true"
import script from "./EditReferatDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditReferatDetail.ts?vue&type=script&lang=ts&external"

import "./EditReferatDetail.vue?vue&type=style&index=0&id=68dfb604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dfb604"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QForm,QTable,QSpace,QInput,QIcon,QTr,QTd,QBtn,QField});
